import {ajax_get, ajax_post} from "./index";

export const getStoreList = (data) => ajax_get('/fe/storeManage/storeList/get/', data);
export const delStoreList = (data) => ajax_post('/fe/storeManage/storeList/delete/', data);
export const insertStoreList = (data) => ajax_post('/fe/storeManage/storeList/insert/', data);
export const editStoreList = (data) => ajax_post('/fe/storeManage/storeList/edit/', data);
export const detailStoreList = (data) => ajax_get('/fe/storeManage/storeList/detail/', data);
export const statisticsStoreByCategory = (data) => ajax_get('/fe/statistics/store/category/get', data);
export const statisticsNewStore = (data) => ajax_get('/fe/statistics/store/new/get', data);
export const statisticsStoreRank = (data) => ajax_get('/fe/statistics/store/rank/get', data);
export const savaScore = (data) => ajax_post('/museumscoresave', data);
export const savaScorenew = (data) => ajax_post('/scoreadjustcalculate4', data);
